export default "__VITE_ASSET__C1UVL$RC__"